import { render, staticRenderFns } from "./VisitHead.vue?vue&type=template&id=6a23ba11&scoped=true"
import script from "./VisitHead.vue?vue&type=script&scoped=true&lang=ts"
export * from "./VisitHead.vue?vue&type=script&scoped=true&lang=ts"
import style0 from "./VisitHead.vue?vue&type=style&index=0&id=6a23ba11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23ba11",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/observation/visit/visit-head.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fobservation%2Fvisit%2FVisitHead.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports